/**
 * Sous-titres EPG publiés pour un programme découpé en parties — miroir de
 * `withPartSuffix` / `sharedPartSubtitle` (backend `lib/epg-programme.ts`)
 * pour l'aperçu de la fiche.
 *
 * - Sous-titre commun (une seule valeur saisie, toutes parties confondues) :
 *   repli de toute partie qui n'en porte pas, partie 1 comprise.
 * - Sinon, une partie suivante sans sous-titre hérite de celui de la partie 1 :
 *   elle continue l'émission que la partie 1 ouvre.
 * - « — Partie N » distingue les lignes, sauf si chaque partie suivante porte
 *   son propre sous-titre et qu'ils diffèrent.
 *
 * `subtitles[0]` est la partie 1, `subtitles[i]` la partie i + 1, déjà
 * nettoyés (vide = hérité).
 */
export function epgPartSubtitles(subtitles: readonly string[]): string[] {
  if (subtitles.length <= 1) return [subtitles[0] || '—']
  const [first, ...rest] = subtitles
  const distinct = new Set(subtitles.filter(Boolean))
  const shared = distinct.size === 1 ? [...distinct][0] : ''
  const individual = rest.every(subtitle => subtitle !== '') && !shared
  return subtitles.map((own, index) => {
    const subject = own || shared || (index > 0 ? first : '')
    if (individual) return subject || '—'
    const part = `Partie ${index + 1}`
    return subject ? `${subject} — ${part}` : part
  })
}

/** Les parties sont-elles publiées sans « — Partie N » ? */
export function epgPartsPublishedAsIs(subtitles: readonly string[]): boolean {
  if (subtitles.length <= 1) return false
  const distinct = new Set(subtitles.filter(Boolean))
  return subtitles.slice(1).every(subtitle => subtitle !== '') && distinct.size !== 1
}
